(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dilauss-beauty-review-picker"] && !Shopify.designMode) return;
  try {
    function initializeBeautyReviewPickers(scope) {
  scope.querySelectorAll('[data-beauty-review-picker]').forEach((picker) => {
    if (picker.dataset.ready) return;
    picker.dataset.ready = 'true';
    const product = picker.closest('product-info');
    const choices = Array.from(picker.querySelectorAll('[data-beauty-review-version]'));
    const gallery = product.querySelector('media-gallery');
    if (product.dataset.productId === '9077800665159' && gallery) {
      const rail = gallery.querySelector('.thumbnail-list');
      if (rail) {
        const keepSelectedVisible = () => {
          if (!window.matchMedia('(min-width:990px)').matches) return;
          const selected = rail.querySelector('.thumbnail[aria-current="true"]');
          const item = selected && selected.closest('.thumbnail-list__item');
          if (!item) return;
          const top = item.offsetTop;
          const bottom = top + item.offsetHeight;
          if (top < rail.scrollTop) rail.scrollTop = top;
          else if (bottom > rail.scrollTop + rail.clientHeight) rail.scrollTop = bottom - rail.clientHeight;
        };
        new MutationObserver(keepSelectedVisible).observe(rail,{subtree:true,attributes:true,attributeFilter:['aria-current']});
        window.addEventListener('resize',keepSelectedVisible);
        keepSelectedVisible();
      }
    }

    const activate = (choice, updateUrl, updateMedia = true) => {
      const price = picker.querySelector('[data-beauty-review-price]');
      price.textContent = choice.dataset.priced === 'true' ? choice.dataset.price : price.dataset.pendingLabel;
      const available = choice.dataset.priced === 'true' && choice.dataset.available === 'true';
      const form = product.querySelector('product-form form');
      if (form) {
        const input = form.querySelector('input[name="id"]');
        if (input) { input.value = choice.value; input.disabled = !available; input.dispatchEvent(new Event('change',{bubbles:true})); }
        const button = form.querySelector('[name="add"]');
        if (button) { button.disabled = !available; button.setAttribute('aria-disabled',String(!available)); button.querySelector('span').textContent = available ? picker.dataset.addLabel : picker.dataset.soldOutLabel; }
      }
      const quantity = product.querySelector('.quantity__input');
      if (quantity) {
        quantity.dataset.min = choice.dataset.quantityMin || '1';
        quantity.dataset.cartQuantity = choice.dataset.cartQuantity || '0';
        quantity.step = choice.dataset.quantityStep || '1';
        if (choice.dataset.quantityMax) quantity.dataset.max = choice.dataset.quantityMax; else delete quantity.dataset.max;
        if (typeof product.setQuantityBoundries === 'function') product.setQuantityBoundries();
        else { quantity.min = quantity.dataset.min; quantity.value = quantity.min; if (choice.dataset.quantityMax) quantity.max = choice.dataset.quantityMax; else quantity.removeAttribute('max'); }
      }
      if (updateMedia && gallery && choice.dataset.mediaId) {
        const id = picker.dataset.sectionId + '-' + choice.dataset.mediaId;
        const target = gallery.querySelector('[data-media-id="' + id + '"]');
        if (target) {
          gallery.querySelectorAll('[data-media-id]').forEach((item) => item.classList.toggle('is-active', item === target));
          target.parentElement.scrollTo({left:target.offsetLeft,behavior:'auto'});
          gallery.querySelectorAll('.thumbnail').forEach((button) => button.removeAttribute('aria-current'));
          const thumbnail = gallery.querySelector('[data-target="' + id + '"]');
          if (thumbnail) { thumbnail.querySelector('button').setAttribute('aria-current','true'); if (typeof gallery.setActiveThumbnail === 'function') gallery.setActiveThumbnail(thumbnail); }
          const live = gallery.querySelector('[id^="GalleryStatus"]');
          if (live) { live.setAttribute('aria-hidden','false'); live.textContent = choice.nextElementSibling.textContent; }
        }
      }
      if (updateUrl) { const url = new URL(window.location.href); url.searchParams.set('variant',choice.value); window.history.replaceState({},'',url); }
    };
    choices.forEach((choice) => choice.addEventListener('change',() => { if (choice.checked) activate(choice,true); }));
    const requested = new URL(window.location.href).searchParams.get('variant');
    const selected = choices.find((choice) => choice.value === requested);
    if (selected) selected.checked = true;
    const syncSelected = () => { const current = choices.find((choice) => choice.checked); if (current) activate(current,false,Boolean(selected)); };
    syncSelected();
    Promise.all([customElements.whenDefined('product-info'),customElements.whenDefined('product-form')]).then(syncSelected);
  });
}
initializeBeautyReviewPickers(document);
document.addEventListener('shopify:section:load',(event) => initializeBeautyReviewPickers(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dilauss-body-edit"] && !Shopify.designMode) return;
  try {
    function initializeDilaussBodyCatalogs(scope) {
  scope.querySelectorAll('[data-body-catalog]').forEach((catalog) => {
    if (catalog.dataset.ready) return;
    catalog.dataset.ready = 'true';
    const filters = Array.from(catalog.querySelectorAll('[data-zone-filter]'));
    const cards = Array.from(catalog.querySelectorAll('[data-body-zone]'));

    filters.forEach((filter) => filter.addEventListener('click', () => {
      const zone = filter.dataset.zoneFilter;
      filters.forEach((button) => button.setAttribute('aria-pressed', String(button === filter)));
      cards.forEach((card) => { card.hidden = zone !== 'all' && !card.dataset.bodyZone.split(' ').includes(zone); });
    }));
  });
}
initializeDilaussBodyCatalogs(document);
document.addEventListener('shopify:section:load', (event) => initializeDilaussBodyCatalogs(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dilauss-camera-picker"] && !Shopify.designMode) return;
  try {
    function initializeDilaussCameraPickers(scope) {
  scope.querySelectorAll('[data-camera-picker]').forEach((picker) => {
    if (picker.dataset.ready) return;
    picker.dataset.ready = 'true';
    const select = picker.querySelector('[data-camera-version]');
    const versions = JSON.parse(picker.querySelector('[data-camera-data]').textContent);
    const french = picker.dataset.locale === 'fr';
    const product = picker.closest('product-info');
    const gallery = product.querySelector('media-gallery');
    const setText = (key, value) => { picker.querySelector('[data-camera-' + key + ']').textContent = value; };
    const activateMedia = (mediaId) => {
      if (!gallery || !mediaId) return;
      const id = picker.dataset.sectionId + '-' + mediaId;
      const target = gallery.querySelector('[data-media-id="' + id + '"]');
      if (!target) return;
      gallery.querySelectorAll('[data-media-id]').forEach((item) => item.classList.toggle('is-active', item === target));
      const slider = target.parentElement;
      slider.scrollTo({left: target.offsetLeft, behavior: 'auto'});
      const thumbnail = gallery.querySelector('[data-target="' + id + '"]');
      gallery.querySelectorAll('.thumbnail').forEach((button) => button.removeAttribute('aria-current'));
      if (thumbnail) {
        thumbnail.querySelector('button').setAttribute('aria-current', 'true');
        if (typeof gallery.setActiveThumbnail === 'function') gallery.setActiveThumbnail(thumbnail);
      }
      const live = gallery.querySelector('[id^="GalleryStatus"]');
      if (live) { live.setAttribute('aria-hidden', 'false'); live.textContent = select.selectedOptions[0].textContent; }
    };
    const syncPurchaseForm = () => {
      const option = select.selectedOptions[0];
      const available = option.dataset.available === 'true';
      const form = product.querySelector('product-form form');
      if (!form) return;
      const input = form.querySelector('input[name="id"]');
      if (input) {
        input.value = select.value;
        input.disabled = !available;
        input.dispatchEvent(new Event('change', {bubbles:true}));
      }
      const button = form.querySelector('[name="add"]');
      if (button) {
        button.disabled = !available;
        button.setAttribute('aria-disabled', String(!available));
        button.querySelector('span').textContent = available ? picker.dataset.addLabel : picker.dataset.soldOutLabel;
      }
      const quantity = product.querySelector('.quantity__input');
      if (quantity) {
        quantity.dataset.min = option.dataset.quantityMin || '1';
        quantity.dataset.cartQuantity = option.dataset.cartQuantity || '0';
        quantity.step = option.dataset.quantityStep || '1';
        if (option.dataset.quantityMax) quantity.dataset.max = option.dataset.quantityMax;
        else delete quantity.dataset.max;
        if (typeof product.setQuantityBoundries === 'function') product.setQuantityBoundries();
        else {
          quantity.min = quantity.dataset.min;
          quantity.value = quantity.min;
          if (option.dataset.quantityMax) quantity.max = option.dataset.quantityMax;
          else quantity.removeAttribute('max');
          quantity.dispatchEvent(new Event('change', {bubbles:true}));
        }
      }
    };
    const normalizeCameraKit = (value) => value === '8-accessory kit' || value === '9-piece kit' ? '9-piece kit' : value;
    const update = (changeUrl) => {
      const version = versions[select.value];
      if (!version) return;
      setText('price', select.selectedOptions[0].dataset.price);
      const comparePrice = picker.querySelector('[data-camera-compare-price]');
      comparePrice.hidden = select.selectedOptions[0].dataset.hasComparePrice !== 'true';
      comparePrice.textContent = comparePrice.hidden ? '' : select.selectedOptions[0].dataset.comparePrice;
      const saving = picker.querySelector('[data-camera-saving]');
      saving.hidden = comparePrice.hidden;
      saving.textContent = comparePrice.hidden ? '' : select.selectedOptions[0].dataset.saving;
      setText('model', version.model);
      setText('colour', french ? version.colourFr : version.colour);
      setText('kit', french ? version.kitFr : normalizeCameraKit(version.kit));
      setText('spec', french ? version.specFr : version.spec);
      picker.querySelector('[data-camera-spec-row]').hidden = !version.spec;
      picker.querySelectorAll('[data-camera-group]').forEach((input) => { input.checked = input.dataset.cameraGroup === 'kit' ? normalizeCameraKit(input.value) === normalizeCameraKit(version.kit) : input.value === version[input.dataset.cameraGroup]; });
      syncPurchaseForm();
      if (changeUrl) activateMedia(select.selectedOptions[0].dataset.mediaId || version.mediaId);
      if (changeUrl) { const url = new URL(window.location.href); url.searchParams.set('variant', select.value); window.history.replaceState({}, '', url); }
    };
    const requested = new URL(window.location.href).searchParams.get('variant');
    if (requested && versions[requested]) select.value = requested;
    picker.querySelectorAll('[data-camera-group]').forEach((input) => input.addEventListener('change', () => {
      const choices = {};
      picker.querySelectorAll('[data-camera-group]:checked').forEach((choice) => { choices[choice.dataset.cameraGroup] = choice.value; });
      const match = Object.entries(versions).find(([, version]) => version.model === choices.model && version.colour === choices.colour && normalizeCameraKit(version.kit) === normalizeCameraKit(choices.kit));
      if (match) { select.value = match[0]; update(true); }
    }));
    update(false);
    Promise.all([customElements.whenDefined('product-info'), customElements.whenDefined('product-form')]).then(syncPurchaseForm);
  });
}
initializeDilaussCameraPickers(document);
document.addEventListener('shopify:section:load', (event) => initializeDilaussCameraPickers(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dilauss-camera-selected-reviews"] && !Shopify.designMode) return;
  try {
    function initializeCameraReviewHighlights(scope) {
  scope.querySelectorAll('[data-camera-highlights]').forEach((section) => {
    if (section.dataset.highlightReady) return;
    section.dataset.highlightReady = 'true';
    const track = section.querySelector('[data-review-track]');
    const cards = Array.from(track.children);
    const previous = section.querySelector('[data-review-prev]');
    const next = section.querySelector('[data-review-next]');
    const count = section.querySelector('[data-review-count]');
    section.querySelector('[data-review-controls]').hidden = false;
    const getIndex = () => Math.max(0, Math.min(cards.length - 1, Math.round(track.scrollLeft / (track.clientWidth + 12))));
    const update = () => {
      const index = getIndex();
      previous.disabled = index === 0;
      next.disabled = index === cards.length - 1;
      count.textContent = (index + 1) + ' / ' + cards.length;
    };
    const move = (step) => {
      const index = Math.max(0, Math.min(cards.length - 1, getIndex() + step));
      track.scrollTo({left:index * (track.clientWidth + 12), behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    };
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('scroll', update, {passive:true});
    track.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); move(event.key === 'ArrowLeft' ? -1 : 1); }
    });
    section.querySelector('[data-review-all]').addEventListener('click', () => {
      const more = document.querySelector('[data-camera-more-reviews]');
      if (more && !more.hidden) more.click();
    });
    update();
  });
}
initializeCameraReviewHighlights(document);
document.addEventListener('shopify:section:load', (event) => initializeCameraReviewHighlights(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dilauss-cart-offer-preview"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dilauss-cart-preview')) {
  customElements.define('dilauss-cart-preview', class extends HTMLElement {
    connectedCallback() {
      const explicitPreview = new URLSearchParams(window.location.search).get('dilauss_cart_preview') === '1';
      if (this.initialized || (!explicitPreview && this.dataset.designMode !== 'true')) return;
      this.initialized = true;
      this.products = JSON.parse(this.querySelector('[data-preview-products]').textContent);
      this.labels = JSON.parse(this.querySelector('[data-preview-labels]').textContent);
      this.dialog = this.querySelector('dialog');
      this.dialog.addEventListener('close', () => document.documentElement.classList.remove('dilauss-cop-modal-open'));
      this.baseSelect = this.querySelector('[data-dilauss-cop-base]');
      this.extraSelect = this.querySelector('[data-dilauss-cop-extra]');
      this.quantity = 1;
      this.selected = false;
      this.baseId = this.products[0].id;
      this.extraId = this.products.find(p => p.title === 'SUYARUN Face & Neck Cream').id;
      this.products.forEach(p => this.baseSelect.add(new Option(p.title, p.id)));
      this.addEventListener('click', event => {
        if (event.target.closest('[data-dilauss-cop-close]')) this.dialog.close();
        if (event.target.closest('[data-dilauss-cop-open]')) this.open();
        if (event.target.closest('[data-dilauss-cop-choose]') && this.quantity === 1) { this.selected = !this.selected; this.renderSelection(); }
        if (event.target === this.dialog) { const r = this.dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dialog.close(); }
      });
      this.addEventListener('change', event => {
        if (event.target.matches('[data-dilauss-cop-base]')) { this.baseId = event.target.value; if(this.extraId === this.baseId) this.extraId = this.products.find(p => p.id !== this.baseId).id; }
        if (event.target.matches('[data-dilauss-cop-extra]')) this.extraId = event.target.value;
        if (event.target.matches('[data-dilauss-cop-qty]')) this.quantity = Number(event.target.value);
        this.selected = false;
        this.render();
      });
      this.hidden = false;
      this.render();
      if (explicitPreview) this.open();
    }
    money(cents) { return 'CA$' + (cents / 100).toFixed(2); }
    node(tag, text, className) { const node = document.createElement(tag); if(text !== undefined) node.textContent = text; if(className) node.className = className; return node; }
    imageFor(product) { const image = this.node('img'); image.src = product.image; image.alt = product.title; image.width = 156; image.height = 176; return image; }
    open() { if (!this.dialog.open) { document.documentElement.classList.add('dilauss-cop-modal-open'); this.dialog.showModal(); } }
    render() {
      const base = this.products.find(p => p.id === this.baseId);
      const extra = this.products.find(p => p.id === this.extraId);
      const baseCard = this.querySelector('[data-dilauss-cop-base-card]'); baseCard.replaceChildren();
      if(this.quantity > 0) { const info = this.node('div'); info.append(this.node('h3',base.title),this.node('p',base.variant),this.node('strong',this.money(base.price)),this.node('p',this.labels.quantity + ': ' + this.quantity)); baseCard.append(this.imageFor(base),info); }
      else baseCard.append(this.node('p',this.labels.empty));
      this.querySelector('[data-dilauss-cop-count]').textContent = this.quantity === 1 ? this.labels.count_one : this.quantity + ' ' + this.labels.count_many;
      this.querySelector('[data-dilauss-cop-subtotal]').textContent = this.money(base.price * this.quantity);
      this.querySelector('[data-dilauss-cop-offer]').hidden = this.quantity !== 1;
      this.querySelector('[data-dilauss-cop-not-eligible]').hidden = this.quantity === 1;
      this.extraSelect.replaceChildren(); this.products.filter(p => p.id !== this.baseId).forEach(p => this.extraSelect.add(new Option(p.title,p.id))); this.extraSelect.value = this.extraId;
      const extraCard = this.querySelector('[data-dilauss-cop-extra-card]'); extraCard.replaceChildren();
      const info = this.node('div'); const prices = this.node('div',undefined,'dilauss-cop-prices'); const discounted = Math.round(extra.price * 0.8);
      const original = this.node('s',this.money(extra.price)); original.setAttribute('aria-label',this.labels.regular_price + ': ' + this.money(extra.price)); prices.append(this.node('strong',this.money(discounted)),original);
      info.append(this.node('h4',extra.title),this.node('p',this.labels.example_variant + ': ' + extra.variant,'dilauss-cop-variant'),this.node('p',this.labels.preview_price,'dilauss-cop-price-label'),prices,this.node('p',this.labels.saving + ': ' + this.money(extra.price-discounted) + ' (20%)','dilauss-cop-saving'));
      extraCard.append(this.imageFor(extra),info); this.renderSelection();
    }
    renderSelection() { const button = this.querySelector('[data-dilauss-cop-choose]'); button.setAttribute('aria-pressed',String(this.selected)); button.textContent = this.selected ? this.labels.chosen + ' · ' + this.labels.remove : this.labels.choose; this.querySelector('[data-dilauss-cop-selection]').textContent = this.selected ? this.labels.selected_note : ''; }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dilauss-foot-overview"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
  const link = event.target.closest('.dilauss-foot-product [data-foot-details]');
  if (!link) return;
  const target = document.querySelector(link.getAttribute('href'));
  if (!target) return;
  const disclosure = target.matches('details') ? target : target.querySelector('details');
  if (disclosure) disclosure.open = true;
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dilauss-foot-picker"] && !Shopify.designMode) return;
  try {
    function initializeDilaussFootPickers(scope) {
  scope.querySelectorAll('[data-foot-picker]').forEach((picker) => {
    if (picker.dataset.ready) return;
    picker.dataset.ready = 'true';
    const product = picker.closest('product-info');
    const choices = Array.from(picker.querySelectorAll('[data-foot-version]'));
    const gallery = product.querySelector('media-gallery');
    const activateMedia = (choice) => {
      if (!gallery || !choice.dataset.mediaId) return;
      const id = picker.dataset.sectionId + '-' + choice.dataset.mediaId;
      const target = gallery.querySelector('[data-media-id="' + id + '"]');
      if (!target) return;
      gallery.querySelectorAll('[data-media-id]').forEach((item) => item.classList.toggle('is-active', item === target));
      target.parentElement.scrollTo({left:target.offsetLeft,behavior:'auto'});
      gallery.querySelectorAll('.thumbnail').forEach((button) => button.removeAttribute('aria-current'));
      const thumbnail = gallery.querySelector('[data-target="' + id + '"]');
      if (thumbnail) {
        thumbnail.querySelector('button').setAttribute('aria-current','true');
        if (typeof gallery.setActiveThumbnail === 'function') gallery.setActiveThumbnail(thumbnail);
      }
      const live = gallery.querySelector('[id^="GalleryStatus"]');
      if (live) { live.setAttribute('aria-hidden','false'); live.textContent = choice.closest('label').textContent.trim(); }
    };
    const synchronize = (changeMedia) => {
      const choice = choices.find((input) => input.checked);
      if (!choice) return;
      const priced = choice.dataset.priceSet === 'true';
      const available = priced && choice.dataset.available === 'true';
      picker.querySelector('[data-foot-price-group]').hidden = !priced;
      picker.querySelector('[data-foot-price-pending]').hidden = priced;
      picker.querySelector('[data-foot-price]').textContent = priced ? choice.dataset.price : '';
      const compare = picker.querySelector('[data-foot-compare-price]');
      compare.hidden = !priced || choice.dataset.hasComparePrice !== 'true';
      compare.textContent = compare.hidden ? '' : choice.dataset.comparePrice;
      const compareGroup = picker.querySelector('[data-foot-compare-group]');
      if (compareGroup) compareGroup.hidden = compare.hidden;
      const saving = picker.querySelector('[data-foot-saving]');
      saving.hidden = compare.hidden;
      saving.textContent = compare.hidden ? '' : choice.dataset.saving;
      product.querySelectorAll('[data-foot-version-overview]').forEach((panel) => { panel.hidden = panel.dataset.footVersionOverview !== choice.value; });
      const component = product.querySelector('product-form');
      const form = component && component.querySelector('form');
      if (component) component.hidden = !priced;
      if (form) {
        const input = form.querySelector('input[name="id"]');
        if (input) { input.value = choice.value; input.disabled = !available; input.dispatchEvent(new Event('change',{bubbles:true})); }
        const button = form.querySelector('[name="add"]');
        if (button) { button.disabled = !available; button.setAttribute('aria-disabled',String(!available)); button.querySelector('span').textContent = available ? picker.dataset.addLabel : picker.dataset.soldOutLabel; }
      }
      const quantityContainer = product.querySelector('.product-form__quantity');
      if (quantityContainer) quantityContainer.hidden = !priced;
      const quantity = product.querySelector('.quantity__input');
      if (quantity) {
        quantity.dataset.min = choice.dataset.quantityMin || '1';
        quantity.dataset.cartQuantity = choice.dataset.cartQuantity || '0';
        quantity.step = choice.dataset.quantityStep || '1';
        if (choice.dataset.quantityMax) quantity.dataset.max = choice.dataset.quantityMax; else delete quantity.dataset.max;
        if (typeof product.setQuantityBoundries === 'function') product.setQuantityBoundries();
        else { quantity.min = quantity.dataset.min; quantity.value = quantity.min; if (choice.dataset.quantityMax) quantity.max = choice.dataset.quantityMax; else quantity.removeAttribute('max'); }
      }
      if (changeMedia) {
        activateMedia(choice);
        const url = new URL(window.location.href); url.searchParams.set('variant',choice.value); window.history.replaceState({},'',url);
      }
      document.dispatchEvent(new CustomEvent('dilauss:foot-version',{detail:{id:choice.value,family:choice.dataset.family}}));
    };
    const requested = new URL(window.location.href).searchParams.get('variant');
    const requestedChoice = choices.find((choice) => choice.value === requested);
    if (requestedChoice) requestedChoice.checked = true;
    else if (requested && choices.length) { const fallback = choices.find((choice) => choice.value === '49081449513031') || choices[0]; fallback.checked = true; const url = new URL(window.location.href); url.searchParams.set('variant',fallback.value); window.history.replaceState({},'',url); }
    choices.forEach((choice) => choice.addEventListener('change',() => synchronize(true)));
    synchronize(Boolean(requestedChoice));
    Promise.all([customElements.whenDefined('product-info'),customElements.whenDefined('product-form')]).then(() => synchronize(false));
  });
}
initializeDilaussFootPickers(document);
document.addEventListener('shopify:section:load',(event) => initializeDilaussFootPickers(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dilauss-posture-overview"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
  const link = event.target.closest('.dilauss-posture-product a[href="#PostureSizeGuide"], .dilauss-posture-product [data-posture-details]');
  if (!link) return;
  const target = document.querySelector(link.getAttribute('href'));
  if (!target) return;
  const disclosure = target.matches('details') ? target : target.querySelector('details');
  if (disclosure) disclosure.open = true;
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dilauss-preview-cart-notice"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit',(event)=>{
  const form=event.target;
  if(!(form instanceof HTMLFormElement)||!form.closest('product-form'))return;
  const product=form.closest('product-info[data-dilauss-preview-only]');
  if(!product)return;
  event.preventDefault();
  event.stopImmediatePropagation();
  let notice=product.querySelector('[data-preview-cart-notice]');
  if(!notice){
    notice=document.createElement('p');
    notice.dataset.previewCartNotice='true';
    notice.className='dilauss-preview-cart-notice';
    notice.setAttribute('role','status');
    form.closest('product-form').after(notice);
  }
  notice.textContent=product.dataset.dilaussPreviewOnly;
},true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dilauss-reference-price"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change',(event)=>{
  const product=event.target.closest('product-info');
  if(!product)return;
  const reference=product.querySelector('[data-dilauss-reference]');
  if(!reference)return;
  const variant=product.querySelector('product-form input[name="id"]');
  const source=reference.querySelector('[data-reference-variants]');
  if(!variant||!source)return;
  const value=JSON.parse(source.textContent)[variant.value];
  if(!value)return;
  reference.hidden=!value.discounted;
  reference.querySelector('[data-reference-amount]').textContent=value.reference;
  reference.querySelector('[data-reference-saving]').textContent=value.saving;
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dilauss-reviewed-catalog-additions"] && !Shopify.designMode) return;
  try {
    function addReviewedCatalogCards() {
  const catalog = document.querySelector('[data-body-catalog]#beauty, [data-body-catalog]#beauty-self-care');
  if (!catalog) return;
  const grid = catalog.querySelector('.dbc-grid');
  if (!grid) return;
  document.querySelectorAll('[data-reviewed-card-template]').forEach((template) => {
    const handle = template.dataset.reviewedHandle;
    if (grid.querySelector('[data-dilauss-card-handle="' + handle + '"]')) return;
    const card = template.content.firstElementChild.cloneNode(true);
    grid.append(card);
    const applyFilter = () => {
      const filter = catalog.querySelector('[data-zone-filter][aria-pressed="true"]');
      const zone = filter ? filter.dataset.zoneFilter : 'all';
      card.hidden = zone !== 'all' && !card.dataset.bodyZone.split(' ').includes(zone);
    };
    catalog.querySelectorAll('[data-zone-filter]').forEach((filter) => filter.addEventListener('click', () => queueMicrotask(applyFilter)));
    applyFilter();
  });
}
addReviewedCatalogCards();
document.addEventListener('shopify:section:load', addReviewedCatalogCards);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dilauss-serum-picker"] && !Shopify.designMode) return;
  try {
    function initializeDilaussSerumPickers(scope) {
  scope.querySelectorAll('[data-serum-picker]').forEach((picker) => {
    if (picker.dataset.ready) return;
    picker.dataset.ready = 'true';
    const product = picker.closest('product-info');
    const choices = Array.from(picker.querySelectorAll('[data-serum-version]'));
    const select = picker.querySelector('select');
    const gallery = product.querySelector('media-gallery');
    const activateMedia = (choice) => {
      if (!gallery || !choice.dataset.mediaId) return;
      const id = picker.dataset.sectionId + '-' + choice.dataset.mediaId;
      const target = gallery.querySelector('[data-media-id="' + id + '"]');
      if (!target) return;
      gallery.querySelectorAll('[data-media-id]').forEach((item) => item.classList.toggle('is-active', item === target));
      target.parentElement.scrollTo({left:target.offsetLeft,behavior:'auto'});
      gallery.querySelectorAll('.thumbnail').forEach((button) => button.removeAttribute('aria-current'));
      const thumbnail = gallery.querySelector('[data-target="' + id + '"]');
      if (thumbnail) {
        thumbnail.querySelector('button').setAttribute('aria-current','true');
        if (typeof gallery.setActiveThumbnail === 'function') gallery.setActiveThumbnail(thumbnail);
      }
      const live = gallery.querySelector('[id^="GalleryStatus"]');
      if (live) { live.setAttribute('aria-hidden','false'); live.textContent = choice.textContent.trim(); }
    };
    const synchronize = (changeMedia) => {
      const choice = choices.find((input) => input.selected);
      if (!choice) return;
      const priced = choice.dataset.priceSet === 'true';
      const available = priced && choice.dataset.available === 'true';
            picker.querySelector('[data-serum-price-group]').hidden = !priced;
      picker.querySelector('[data-serum-price-pending]').hidden = priced;
      picker.querySelector('[data-serum-price]').textContent = priced ? choice.dataset.price : '';
      product.classList.toggle('dilauss-serum-priced',priced);
      const component = product.querySelector('product-form');
      const form = component && component.querySelector('form');
      if (component) component.hidden = !priced;
      if (form) {
        const input = form.querySelector('input[name="id"]');
        if (input) { input.value = choice.value; input.disabled = !available; input.dispatchEvent(new Event('change',{bubbles:true})); }
        const button = form.querySelector('[name="add"]');
        if (button) { button.disabled = !available; button.setAttribute('aria-disabled',String(!available)); button.querySelector('span').textContent = available ? picker.dataset.addLabel : picker.dataset.soldOutLabel; }
      }
      const quantityContainer = product.querySelector('.product-form__quantity');
      if (quantityContainer) quantityContainer.hidden = !priced;
      const quantity = product.querySelector('.quantity__input');
      if (quantity) {
        quantity.dataset.min = choice.dataset.quantityMin || '1';
        quantity.dataset.cartQuantity = choice.dataset.cartQuantity || '0';
        quantity.step = choice.dataset.quantityStep || '1';
        if (choice.dataset.quantityMax) quantity.dataset.max = choice.dataset.quantityMax; else delete quantity.dataset.max;
        if (typeof product.setQuantityBoundries === 'function') product.setQuantityBoundries();
        else { quantity.min = quantity.dataset.min; quantity.value = quantity.min; if (choice.dataset.quantityMax) quantity.max = choice.dataset.quantityMax; else quantity.removeAttribute('max'); }
      }
      if (changeMedia) {
        activateMedia(choice);
        const url = new URL(window.location.href); url.searchParams.set('variant',choice.value); window.history.replaceState({},'',url);
      }
      document.dispatchEvent(new CustomEvent('dilauss:serum-version',{detail:{id:choice.value}}));
    };
    const requested = new URL(window.location.href).searchParams.get('variant');
    const requestedChoice = choices.find((choice) => choice.value === requested);
    if (requestedChoice) requestedChoice.selected = true;
    else if (requested && choices.length) { const fallback = choices.find((choice) => choice.value === '49108609499207') || choices[0]; fallback.selected = true; const url = new URL(window.location.href); url.searchParams.set('variant',fallback.value); window.history.replaceState({},'',url); }
    select.addEventListener('change',() => synchronize(true));
    synchronize(Boolean(requestedChoice));
    Promise.all([customElements.whenDefined('product-info'),customElements.whenDefined('product-form')]).then(() => synchronize(false));
  });
}
initializeDilaussSerumPickers(document);
document.addEventListener('shopify:section:load',(event) => initializeDilaussSerumPickers(event.target));
  } catch(e) { console.error(e); }
})();

})();
